var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-simplemde',{ref:"markdownEditor",staticClass:"bg-white",attrs:{"model-value":_vm.content,"configs":_vm.config},on:{"update:modelValue":function($event){return _vm.$emit('update:content', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }